import { AdCommentPin } from "../../marketing-review-interfaces/marketing-review.interface";

export class ReviewAdModel {

    private commentId!: number;
    private commentedBy!: string;
    private piasRepCode!: string;
    private description!: string;
    private status!: string;
    private replayId!: number;
    private replayCommend!: string;
    private pin!: AdCommentPin;

    constructor() { }


    // Getters & Setters
    getCommentId(): number {
        return this.commentId;
    }
    setCommentId(commentId: number) {
        this.commentId = commentId;
    }

    getCommentedBy(): string {
        return this.commentedBy;
    }

    setCommentedBy(commentedBy: string) {
        this.commentedBy = commentedBy;
    }

    getPiasRepCode(): string {
        return this.piasRepCode;
    }

    setPiasRepCode(piasRepCode: string) {
        this.piasRepCode = piasRepCode;
    }

    getDescription(): string {
        return this.description;
    }

    setDescription(description: string) {
        this.description = description;
    }

    getPin() {
        return this.pin;
    }

    setPin(data: AdCommentPin) {
        this.pin = data;
    }

    getReplayId(): number {
        return this.replayId;
    }
    setReplayId(replayId: number) {
        this.replayId = replayId;
    }

    getReplayCommend(): string {
        return this.replayCommend;
    }

    setReplayCommend(replayCommend: string) {
        this.replayCommend = replayCommend;
    }

    getStatus(): string {
        return this.status;
    }

    setStatus(status: string) {
        this.status = status;
    }




    toString() {
        return JSON.stringify({
            commentedBy: this.getCommentedBy(),
            piasRepCode: this.getPiasRepCode(),
            description: this.getDescription(),
            status: this.getStatus(),
            replayId: this.getReplayId(),
            replayCommend: this.getReplayCommend(),
            pin: this.getPin()
        });
    }

    updatetoString() {
        return JSON.stringify({
            commentId: this.getCommentId(),
            commentedBy: this.getCommentedBy(),
            piasRepCode: this.getPiasRepCode(),
            description: this.getDescription(),
            status: this.getStatus(),
            replayId: this.getReplayId(),
            replayCommend: this.getReplayCommend(),
            pin: this.getPin()
        });
    }
}
